import { makeStyles } from "@fluentui/react-components";

export const useSettingsStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontWeight: "600",
  },
  form: {
    paddingBlock: "20px",
  },
  fieldContainer: {
    marginBottom: "20px",
  },
  input: {
    width: "100%",
  },
  errorText: {
    color: "red",
    marginTop: "4px",
    marginBottom: "16px",
  },
});
